// https://colors.eva.design/?utm_campaign=eva_colors%20-%20home%20-%20eva_design%20website&utm_source=eva_design&utm_medium=referral&utm_content=eva_website_menu

import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export type ColorSchema = 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';

declare module '@mui/material/styles/createPalette' {
  interface TypeBackground {
    neutral: string;
    docread: string;
  }
  interface SimplePaletteColorOptions {
    lighter: string;
    darker: string;
  }
  interface PaletteColor {
    lighter: string;
    darker: string;
  }
}

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

/*
const PRIMARY = {
  lighter: '#CBFEFC',
  light: '#64ECFB',
  main: '#00B9F4',
  dark: '#006CAF',
  darker: '#003775',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#CBFED5',
  light: '#64FC9F',
  main: '#00F590',
  dark: '#00B08A',
  darker: '#007573',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#E2E6FF',
  light: '#A9B4FF',
  main: '#7080FF',
  dark: '#3843B7',
  darker: '#151C7A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#EDFBD0',
  light: '#B4E972',
  main: '#61B71B',
  dark: '#35830D',
  darker: '#185705',
  contrastText: '#1A5105',
};

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFDF69',
  main: '#FFBC05',
  dark: '#B77D02',
  darker: '#7A4C00',
  contrastText: '#999999',
};

const ERROR = {
  lighter: '#FFEAD7',
  light: '#FFB087',
  main: '#FF5F38',
  dark: '##B7231C',
  darker: '#7A0A16A',
  contrastText: '#fff',
};
*/

const PRIMARY = {
  lighter: '#CCFFFD',
  light: '#66ECFF',
  main: '#0093DB',
  dark: '#006EB7',
  darker: '#00387A',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#CBFEE2',
  light: '#63F9C4',
  main: '#00ECC5',
  dark: '#00A6A9',
  darker: '#005971',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#CAFDF5',
  light: '#61F3F3',
  main: '#00B8D9',
  dark: '#006C9C',
  darker: '#003768',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#D8FBDE',
  light: '#86E8AB',
  main: '#36B37E',
  dark: '#1B806A',
  darker: '#0A5554',
  contrastText: '#fff',
};

const WARNING = {
  lighter: '#FFF5CC',
  light: '#FFD666',
  main: '#FFAB00',
  dark: '#B76E00',
  darker: '#7A4100',
  contrastText: '#999999',
};

const ERROR = {
  lighter: '#FFE9D5',
  light: '#FFAC82',
  main: '#FF5630',
  dark: '#B71D18',
  darker: '#7A0916',
  contrastText: '#fff',
};

const COMMON = {
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.2),
  action: {
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export function palette(mode: 'light' | 'dark') {
  const light = {
    ...COMMON,
    mode: 'light',
    text: {
      primary: GREY[800],
      secondary: GREY[600],
      disabled: GREY[500],
    },
    background: {
      paper: '#FFFFFF',
      default: '#FFFFFF',
      neutral: GREY[200],
      docread: '#002F40'
    },
    action: {
      ...COMMON.action,
      active: GREY[600],
    },
  };

  const dark = {
    ...COMMON,
    mode: 'dark',
    text: {
      primary: '#FFFFFF',
      secondary: GREY[500],
      disabled: GREY[600],
    },
    background: {
      paper: GREY[800],
      default: GREY[900],
      neutral: alpha(GREY[500], 0.12),
    },
    action: {
      ...COMMON.action,
      active: GREY[500],
    },
  };

  return mode === 'light' ? light : dark;
}
